export default __webpack_public_path__ + "static/Gamification-cf80bcfde96063524f6e78d0e4d3145a.webp";